
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 23","fill":"inherit","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.719 21.558a3.517 3.517 0 004.972 0L18.844 9.405a5.076 5.076 0 00.02-7.202 5.078 5.078 0 00-7.201.02l-8.01 8.01.552.553 8.01-8.01a4.298 4.298 0 017.356 3.032 4.297 4.297 0 01-1.28 3.044L6.14 21.005a2.735 2.735 0 01-3.868-3.867L12.767 6.642A1.172 1.172 0 0114.425 8.3l-6.353 6.353.552.552 6.353-6.353a1.953 1.953 0 00-2.762-2.762L1.72 16.586a3.515 3.515 0 000 4.972z"}})])
          )
        }
      }
    